module.exports = __webpack_public_path__ + "static/media/title2.6b5d7982.jpg";